export default __webpack_public_path__ + "static/media/logo_Femimed.a66a9f13.webp";